import { observable } from 'mobx'

/*
    groupInfoIntergrity number 填写完整度
    groupNoGroup boolean 提示没有团队弹窗
    groupBuildGroup boolean 创建团队弹窗
    buildSuccess boolean 创建成功弹窗
*/

class CreateGroupStore {
  @observable groupInfoIntergrity = 0
  @observable groupNoGroup = true
  @observable groupBuildGroup = false
  @observable buildSuccess = false
}
const store = new CreateGroupStore()
export default store



// WEBPACK FOOTER //
// ./src/store/CreateGroupStore.js